export default function time(date, locale, options = {}) {
  return new Intl.DateTimeFormat(locale, ({
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    // hour12: false,
    ...options
  })).format(date)
}
